import { useNavigate } from "react-router-dom";

import { BusinessRounded, EmojiEventsRounded, GroupsRounded } from "@mui/icons-material";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import { EmailType } from "@interfaces/campaign.type";

import theme from "@theme/index";

interface IMetricCardsProperties {
  campaignId: string;
  emails: EmailType[];
}

const iconStyles = {
  color: theme.palette.primary.main,
  height: "35px",
  width: "35px",
};

export default function MetricCards({ campaignId, emails }: IMetricCardsProperties) {
  const navigate = useNavigate();

  const numberUniqueCompanies = new Set(emails.map((email) => email?.company?.id)).size;
  const numberLeads = emails.filter((email) => email.status.lead === true).length;

  const itemsToRender = [
    {
      icon: <GroupsRounded sx={iconStyles} />,
      onClick: () => navigate(`/campaigns/${campaignId}/contacts?section=all`),
      title: "contacts reached",
      tooltip: "View contacts you've reached.",
      value: emails.length > 0 ? emails.length : "-",
    },
    {
      icon: <BusinessRounded sx={iconStyles} />,
      title: "companies reached",
      tooltip: "",
      value: numberUniqueCompanies || "-",
    },
    {
      icon: <EmojiEventsRounded sx={iconStyles} />,
      onClick: () => navigate(`/campaigns/${campaignId}/contacts?section=leads`),
      title: "leads",
      tooltip: "View leads from this Campaign.",
      value: numberLeads || "-",
    },
  ];

  return (
    <Grid container spacing={2}>
      {itemsToRender.map((item, index) => (
        <Grid item key={index} lg={4} xs={12}>
          <Card
            onClick={item.value === "-" ? undefined : item.onClick}
            sx={{
              "&:hover": {
                boxShadow: item.onClick && item.value !== "-" ? theme.shadows[3] : theme.shadows[1],
              },
              backgroundColor: theme.palette.grey[50],
              color: theme.palette.primary.contrastText,
              cursor: item.onClick && item.value !== "-" ? "pointer" : "default",
              display: "flex",
              flexDirection: "column",
              height: "125px",
              transition: "all 0.1s ease-in-out",
            }}
          >
            <Tooltip placement="bottom" title={item.tooltip}>
              <CardContent
                sx={{
                  alignItems: "center",
                  display: "flex",
                  gap: 2,
                  height: "100%",
                  justifyContent: "center",
                }}
              >
                {item.icon}
                <Typography variant="h4">{item.value}</Typography>
                <Typography fontWeight={600} variant="body2">
                  {item.title}
                </Typography>
              </CardContent>
            </Tooltip>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
